import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormMoneyField from '../../../FormFields/FormMoneyField';
import FormTextField from '../../../FormFields/FormTextField';
import FormTitle from '../../../FormFields/FormTitle';
import FormVendorField from '../../../FormFields/FormVendorField';
import { formCardStyle } from '../../../TransitionStyles';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { TELECOMMUNICATIONS } from '../../../formQuestionsEnum';

PhoneForm.propTypes = {
  permissions: PropTypes.object,
};

export default function PhoneForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [
    TELECOMMUNICATIONS.PHONE_SERVICE_PROVIDER.id,
    TELECOMMUNICATIONS.PHONE_MONTHLY_COST.id,
    TELECOMMUNICATIONS.IS_PHONE_EQUIPMENT_LEASED.id,
    TELECOMMUNICATIONS.PHONE_LEASE_MONTHLY_COST.id,
    TELECOMMUNICATIONS.PHONE_MAKE.id,
    TELECOMMUNICATIONS.PHONE_MODEL.id,
    TELECOMMUNICATIONS.EQUIPMENT_SERVICE_PROVIDER.id,
  ];

  const showForm = fieldIds.some((id) => id in permissions);

  const { watch } = useFormContext();
  const equipmentLeased = watch(TELECOMMUNICATIONS.IS_PHONE_EQUIPMENT_LEASED.fieldName);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Phone
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {TELECOMMUNICATIONS.PHONE_SERVICE_PROVIDER.id in permissions && (
            <Grid item xs={12}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'Phone service provider', fieldType: 'title' }} />
                <FormVendorField
                  fieldName={TELECOMMUNICATIONS.PHONE_SERVICE_PROVIDER.fieldName}
                  fieldAttributes={{ isEditable: permissions[TELECOMMUNICATIONS.PHONE_SERVICE_PROVIDER.id] }}
                  invoiceFileTypeId={FILE_TYPES.PHONE_SERVICE_PROVIDER_INVOICE}
                  contractFileTypeId={FILE_TYPES.PHONE_SERVICE_PROVIDER_CONTRACT}
                />
              </FieldContainer>
            </Grid>
          )}
          {TELECOMMUNICATIONS.PHONE_MONTHLY_COST.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Current monthly cost' }} />
              <FormMoneyField
                fieldName={TELECOMMUNICATIONS.PHONE_MONTHLY_COST.fieldName}
                fieldAttributes={{
                  isEditable: permissions[TELECOMMUNICATIONS.PHONE_MONTHLY_COST.id],
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
            </Grid>
          )}
          {TELECOMMUNICATIONS.IS_PHONE_EQUIPMENT_LEASED.id in permissions && (
            <Grid item xs={12}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'Equipment' }} />
                <FormButtonOptions
                  fieldName={TELECOMMUNICATIONS.IS_PHONE_EQUIPMENT_LEASED.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[TELECOMMUNICATIONS.IS_PHONE_EQUIPMENT_LEASED.id],
                    options: [
                      { label: 'Owned', value: false },
                      { label: 'Leased', value: true },
                    ],
                  }}
                />
              </FieldContainer>
            </Grid>
          )}
          {equipmentLeased && TELECOMMUNICATIONS.PHONE_LEASE_MONTHLY_COST.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Monthly cost to lease' }} />
              <FormMoneyField
                fieldName={TELECOMMUNICATIONS.PHONE_LEASE_MONTHLY_COST.fieldName}
                fieldAttributes={{
                  isEditable: permissions[TELECOMMUNICATIONS.PHONE_LEASE_MONTHLY_COST.id],
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
            </Grid>
          )}
          {TELECOMMUNICATIONS.PHONE_MAKE.id in permissions && (
            <Grid item xs={12} lg={6}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'Make' }} />
                <FormTextField
                  fieldName={TELECOMMUNICATIONS.PHONE_MAKE.fieldName}
                  fieldAttributes={{ isEditable: permissions[TELECOMMUNICATIONS.PHONE_MAKE.id] }}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                />
              </FieldContainer>
            </Grid>
          )}
          {TELECOMMUNICATIONS.PHONE_MODEL.id in permissions && (
            <Grid item xs={12} lg={6}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'Model' }} />
                <FormTextField
                  fieldName={TELECOMMUNICATIONS.PHONE_MODEL.fieldName}
                  fieldAttributes={{ isEditable: permissions[TELECOMMUNICATIONS.PHONE_MODEL.id] }}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                />
              </FieldContainer>
            </Grid>
          )}
          {TELECOMMUNICATIONS.EQUIPMENT_SERVICE_PROVIDER.id in permissions && (
            <Grid item xs={12}>
              <FieldContainer>
                <FormTitle
                  fieldAttributes={{ questionTitle: 'Current equipment service provider', fieldType: 'title' }}
                />
                <FormVendorField
                  fieldName={TELECOMMUNICATIONS.EQUIPMENT_SERVICE_PROVIDER.fieldName}
                  fieldAttributes={{ isEditable: permissions[TELECOMMUNICATIONS.EQUIPMENT_SERVICE_PROVIDER.id] }}
                  invoiceFileTypeId={FILE_TYPES.PHONE_EQUIPMENT_PROVIDER_INVOICE}
                  contractFileTypeId={FILE_TYPES.PHONE_EQUIPMENT_PROVIDER_CONTRACT}
                />
              </FieldContainer>
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
